<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed, ref } from 'vue';
import PopupMenuItem from '@/components/common/popup/PopupMenuItem.vue';
import type { DisplayValueType } from '@/models/common/ValueTypes';
import SearchBar from '@/components/common/forms/SearchBar.vue';

type ExtendedParams = ICellRendererParams<any, void> & {
    selectedValue: DisplayValueType<any> | null;
    options: DisplayValueType<any>[],
    wrapText: boolean;
    select: (value: any) => void;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const searchString = ref('');

const selectedValue = computed<DisplayValueType<any> | null>(() => props.params.selectedValue);
const wrapText = computed<boolean>(() => props.params.wrapText);

const filteredOptions = computed<DisplayValueType<any>[]>((): DisplayValueType<any>[] => (
    props.params.options.filter(option => option.display.toLowerCase().includes(searchString.value.toLowerCase()))
));

function closePopup():void {
    props.params.api.stopEditing();
}

function select(value: any): void {
    props.params.select(value);

    closePopup();
}
</script>

<template>
    <div @blur="closePopup">
        <div>
            <div class="padding-5 padding-bottom-3">
                <SearchBar
                    v-model="searchString"
                    class="margin-bottom-3"
                    :autofocus="true"
                />
            </div>
            <div class="sy-node-list">
                <PopupMenuItem
                    v-for="(item,) of filteredOptions"
                    :key="item.value"
                    :text="item.display"
                    :wrap-text="wrapText"
                    :selected="selectedValue?.value === item.value"
                    @click="select(item.value)"
                />
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.sy-node-list {
    max-height: 400px;
    width: 100%;
    overflow: auto;
}
</style>
